import { z } from 'zod';

export const pipelineStages = ['new', 'contacted', 'qualified', 'interested', 'committed', 'participant', 'closed_lost'] as const;

export const prospectSchema = z.object({
  company: z.string().min(1, 'Company name is required'),
  contactName: z.string().min(1, 'Contact name is required'),
  email: z.string().email('Valid email is required'),
  phone: z.string().optional(),
  title: z.string().optional(),
  stage: z.enum(pipelineStages),
  notes: z.string().optional(),
  isPrimaryContact: z.boolean().optional(),
});

export const csvProspectSchema = z.object({
  company: z.string().min(1, 'Company name is required'),
  contactName: z.string().min(1, 'Contact name is required'),
  email: z.string().email('Valid email is required'),
  notes: z.string().optional().default(''),
});

export type ProspectFormData = z.infer<typeof prospectSchema>;
export type CsvProspectData = z.infer<typeof csvProspectSchema>;